import { passwordRulesPass } from '@/utils/password-rules';
import { validatePhone } from '@/utils/phone-digits';
import { translateErrorMap } from './field-error-messages';
import type {
  NewMemberData,
  NewMemberFieldErrors,
} from '../hooks/use-new-member-form';

const REQUIRED: (keyof NewMemberData)[] = [
  'first_name',
  'last_name',
  'personal_ig_username',
  'email',
  'phone_prefix',
  'phone_number',
  'country',
  'city',
  'birthdate',
  'password',
];

function validatePassword(d: NewMemberData, errs: NewMemberFieldErrors): void {
  if (!d.password) return;
  if (passwordRulesPass(d.password, d.password_confirm)) return;
  errs.password = 'password_invalid';
  if (d.password_confirm && d.password !== d.password_confirm) {
    errs.password_confirm = 'password_mismatch';
  }
}

export function validateClientSide(d: NewMemberData): NewMemberFieldErrors {
  const errs: NewMemberFieldErrors = {};
  REQUIRED.forEach((k) => {
    if (!d[k]) errs[k] = 'required';
  });
  if (d.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) {
    errs.email = 'email_format';
  }
  if (d.phone_prefix && d.phone_number) {
    const res = validatePhone(
      d.phone_prefix + d.phone_number.replace(/\s/g, '')
    );
    if (!res.ok) errs.phone_number = res.code;
  }
  validatePassword(d, errs);
  return translateErrorMap(errs);
}
